<template>
  <component
    :is="isClickable ? 'BaseLink' : 'div'"
    :class="classes"
    :to="isClickable ? link : null"
  >
    <div
      v-if="$slots.media"
      :class="$b('media')"
    >
      <div :class="$b('media-container')">
        <slot name="media" />
      </div>
    </div>

    <div
      v-if="$slots.subtitle"
      :class="$b('subtitle')"
    >
      <slot name="subtitle" />
    </div>

    <div
      v-if="$slots.heading"
      :class="$b('heading')"
    >
      <slot name="heading" />
    </div>

    <div
      v-if="$slots.copy"
      :class="$b('copy')"
    >
      <slot
        v-if="$slots.copy"
        name="copy"
      />
    </div>

    <div
      v-if="$slots.controls"
      :class="$b('controls')"
    >
      <slot name="controls" />
    </div>
  </component>
</template>

<script>
import { BaseLink } from '#components'

export default {
  name: 'BaseStack',

  components: {
    BaseLink
  },

  props: {
    hasMedia: {
      type: Boolean,
      default: false
    },

    rowHasMedia: {
      type: Boolean,
      default: false
    },

    fullHeight: {
      type: Boolean,
      default: false
    },

    link: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'small'
        ].includes(value)
      }
    }
  },

  computed: {
    isClickable () {
      return !!this.link
    },

    classes () {
      return {
        BaseStack: true,
        'BaseStack--clickable': this.isClickable,
        [`BaseStack--${this.size}`]: this.size,
        'BaseStack--no-media': !this.hasMedia && this.rowHasMedia,
        'BaseStack--full-height': this.fullHeight
      }
    }
  }
}
</script>

<style lang="postcss">
.BaseStack {
  @apply h-full;
}

.BaseStack > :last-child {
  @apply !mb-0;
}

.BaseStack--full-height {
  @apply h-full;

  .BaseStack__media {
    @apply h-full;
  }
}

.BaseStack__media {
  @apply rounded-[10px] overflow-hidden will-change-transform;
}

.BaseStack__media,
.BaseStack__heading,
.BaseStack__copy {
  @apply mb-sm;
}

.BaseStack__copy {
  @screen md {
    @apply w-5/6;
    max-width: 82%;
  }
}

.BaseStack__subtitle {
  @apply mb-xxs;
}

.BaseStack__media-container {
  @apply h-full;
}

.BaseStack--clickable {
  @apply cursor-pointer;

  &:hover {
    @apply text-off-black;
  }
}

.BaseStack--no-media {
  @screen lg {
    @apply pt-lg;
  }
}

.BaseStack--small {
  .BaseStack__heading,
  .BaseStack__copy {
    @apply mb-xxs;
  }

  .BaseStack__copy {
    @apply w-full;
  }
}
</style>
